require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-boiler-house-the-local-project.json") })
        }
      }, "path---news-boiler-house-the-local-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-boiler-house-the-local-project!./.cache/json/news-boiler-house-the-local-project.json
// module id = 798
// module chunks = 231608221292675